var _path, _path2, _path3, _circle, _path4, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "productsicon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.379,
    height: 47,
    viewBox: "0 0 48.379 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_16999",
    "data-name": "Path 16999",
    d: "M7.764,7.528H35.992a1.764,1.764,0,1,0,0-3.528H7.764a1.764,1.764,0,0,0,0,3.528Z",
    transform: "translate(10.623 -2.236)",
    fill: "#1f54cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17000",
    "data-name": "Path 17000",
    d: "M35.992,11H7.764a1.764,1.764,0,0,0,0,3.528H35.992a1.764,1.764,0,1,0,0-3.528Z",
    transform: "translate(10.623 10.179)",
    fill: "#1f54cc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17001",
    "data-name": "Path 17001",
    d: "M35.992,18H7.764a1.764,1.764,0,1,0,0,3.528H35.992a1.764,1.764,0,1,0,0-3.528Z",
    transform: "translate(10.623 22.797)",
    fill: "#1f54cc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1637",
    "data-name": "Ellipse 1637",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#1f54cc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17002",
    "data-name": "Path 17002",
    d: "M3.5,0A3.542,3.542,0,0,1,7,3.582a3.928,3.928,0,0,1-.438,1.736A3.385,3.385,0,0,1,3.5,7.165,3.542,3.542,0,0,1,0,3.582,3.542,3.542,0,0,1,3.5,0Z",
    transform: "translate(0 19)",
    fill: "#1f54cc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1639",
    "data-name": "Ellipse 1639",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(0 40)",
    fill: "#1f54cc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsicon);
export default __webpack_public_path__ + "static/media/productsicon.d854a2106932f4cd67f6787068b81da2.svg";
export { ForwardRef as ReactComponent };